/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getUserTiles} from '../api'

 export const useQueryGetUserTiles = createReactQueryHook('getUserTiles', getUserTiles)
